var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTasks = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "board"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.17872 0H45.7532C46.9565 0 47.9319 0.975448 47.9319 2.17872V45.7532C47.9319 46.9565 46.9565 47.9319 45.7532 47.9319H2.17872C0.975448 47.9319 0 46.9565 0 45.7532V2.17872C0 0.975448 0.975448 0 2.17872 0ZM4.35745 43.5745H43.5745V4.35745H4.35745V43.5745Z",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M13.0723 37.0382C14.2756 37.0382 15.251 36.0627 15.251 34.8595V19.6084C15.251 18.4051 14.2756 17.4297 13.0723 17.4297C11.869 17.4297 10.8936 18.4051 10.8936 19.6084V34.8595C10.8936 36.0627 11.869 37.0382 13.0723 37.0382Z",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M23.9658 37.0382C25.1691 37.0382 26.1446 36.0628 26.1446 34.8595V13.0723C26.1446 11.869 25.1691 10.8936 23.9658 10.8936C22.7626 10.8936 21.7871 11.869 21.7871 13.0723V34.8595C21.7871 36.0628 22.7626 37.0382 23.9658 37.0382Z",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M34.8594 37.0382C36.0627 37.0382 37.0381 36.0627 37.0381 34.8595V19.6084C37.0381 18.4051 36.0627 17.4297 34.8594 17.4297C33.6561 17.4297 32.6807 18.4051 32.6807 19.6084V34.8595C32.6807 36.0627 33.6561 37.0382 34.8594 37.0382Z",
    fill: "#979797"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTasks);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tasks.323007c35c3c3ac668aeabe7507c4b2a.svg";